import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CheckIcon from "@mui/icons-material/Check";

const OnboardingChecklistTimelineStep = ({
  step,
  isLast = false,
  title,
  description,
  onActionStep,
}) => {
  const isInteractive = !step.completed;

  const onStepClick = () => {
    if (!isInteractive) {
      return;
    }

    onActionStep({ actionKey: step.actionKey });
  };

  const onStepKeyDown = (event) => {
    if (!isInteractive) {
      return;
    }

    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onActionStep({ actionKey: step.actionKey });
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {step.completed ? (
          <Box
            aria-hidden
            sx={{
              width: 32,
              height: 32,
              borderRadius: "999px",
              bgcolor: "success.main",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <CheckIcon
              sx={{ fontSize: 18, fontWeight: 700, color: "#fff !important" }}
            />
          </Box>
        ) : (
          <Box
            aria-hidden
            sx={{
              width: 32,
              height: 32,
              borderRadius: "999px",
              border: "2px solid",
              borderColor: "grey.300",
              bgcolor: "background.paper",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: 600,
                color: "text.secondary",
              }}
            >
              {step.id}
            </Typography>
          </Box>
        )}

        {!isLast ? (
          <Box
            sx={{
              width: "1px",
              flex: 1,
              bgcolor: "grey.300",
              my: 0.5,
              minHeight: 20,
            }}
          />
        ) : null}
      </Box>

      <Box
        role={isInteractive ? "button" : undefined}
        tabIndex={isInteractive ? 0 : undefined}
        onClick={onStepClick}
        onKeyDown={onStepKeyDown}
        sx={{
          flex: 1,
          pb: isLast ? 1 : 2.5,
          cursor: isInteractive ? "pointer" : "default",
          "&:focus-visible": {
            outline: "none",
          },
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 600,
            lineHeight: 1.3,
            mt: 0.75,
            color: step.completed ? "text.secondary" : "text.primary",
          }}
        >
          {title}
        </Typography>

        {!step.completed && description ? (
          <Typography
            sx={{
              fontSize: "14px",
              color: "text.secondary",
              mt: 0.25,
              lineHeight: 1.5,
            }}
          >
            {description}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
};

export default OnboardingChecklistTimelineStep;
